import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed } from '@nuxtjs/composition-api';

export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const store = useStore();
const { loggedInUser } = store.getters;

const getPlanName = computed(() => {
  return loggedInUser.subscription && loggedInUser.subscription.code !== 'free'
    ? loggedInUser.subscription.name
    : loggedInUser.role.replace(/_/g, ' ');
});

return { __sfc: true,store, loggedInUser, getPlanName }
}

})